import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import AddToleranceMaster from "./AddToleranceMaster";
import ACTIONS from "../../../../common/action_constant";
import LoaderComponent from "src/common/components/loader/loader";
import { getUserId } from "../../../../utils/common.js";

class ToleranceMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      toleranceData: [],
      isOpen: false,
      editData: "",
    };
  }

  componentDidMount() {
    this.getToleranceMasterData();
    this.getMaterialData("");
  }

  getToleranceMasterData = () => {
    const { dispatch, companyId, branchId } = this.props;
    const { search, offset, limit } = this.state;
    let params = { companyId, branchId, limit, offset };
    if (search) {
      params.search = search;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_TOLERANCE_MASTER,
      params,
      onSuccess: (data) => {
        this.setState({ toleranceData: data && data.list ? data.list : data });
      },
    });
  }

  changeHandler = (value) => {
    this.setState({ search: value });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getToleranceMasterData);
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getToleranceMasterData);
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  editToleranceMaster = (data) => {
    this.setState({ editData: data, isOpen: true });
  };

  getMaterialData = (search) => {
    const { dispatch, companyId } = this.props;
    const param = `${companyId}&search=${search}`;
    dispatch({
      type: ACTIONS.MASTER.INVENTORY_ITEM.GET_INVENTORY_ITEM,
      param,
      onSuccess: (data) => {
        const rawList = (data && data.list && data.list.productMasters) || [];
        const materialOptions = rawList.map((option) => ({
          label: `${option.material_code} - ${option.materialName}`,
          value: option.material_code,
          ...option,
        }));
        this.setState({ materialOptions });
      },
    });
  };

  deleteToleranceMaster = (data) => {
    const { dispatch, companyId, branchId } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_TOLERANCE_MASTER,
      data,
      onSuccess: () => {
        this.getToleranceMasterData();
      },
    });
  };

  onSaveToleranceMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_TOLERANCE_MASTER,
      data,
      onSuccess: () => {
        this.setState({ isOpen: false }, this.getToleranceMasterData);
      },
    });
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId, branchId } = this.props;
    const masterType = 64;
    history.push(`/auditScreen/${companyId}/${masterType}/${branchId}`);
  };

  uploadExcelFile = (e) => {
    const { dispatch, companyId, branchId } = this.props;
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    dispatch({
      type: ACTIONS.PLANTS.UPLOAD_TOLERANCE_MASTER,
      data: formData,
      param: { companyId, branchId, userId: getUserId() },
      onSuccess: (presignedUrlData) => {
        if (presignedUrlData?.url) {
          window.location.href = presignedUrlData.url;
        }
        this.getToleranceMasterData();
      },
    });
  };

  downloadTemplate = () => {
    const { dispatch, companyId, branchId } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DOWNLOAD_TOLERANCE_MASTER_TEMPLATE,
      params: { companyId, branchId },
      onSuccess: (presignedUrlData) => {
        if (presignedUrlData?.url) {
          window.location.href = presignedUrlData.url;
        }
      },
    });
  };

  onUpdateToleranceMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_TOLERANCE_MASTER,
      data: { ...data, previous_data: this.state.editData },
      onSuccess: () => {
        this.setState({ isOpen: false, editData: "" }, this.getToleranceMasterData);
      },
    });
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({ offset: prevState.offset - prevState.limit }),
        this.getToleranceMasterData
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({ offset: prevState.offset + prevState.limit }),
      this.getToleranceMasterData
    );
  };

  render() {
    const { toleranceData } = this.state;
    const { loader } = this.props;

    return (
      <div className="location-network">
        {!!loader.loaderT1 && <LoaderComponent />}
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value="+ Add Tolerance" click={this.toggleAdd} />
            <Button value="Audit" click={this.handleOnClickForAuditBtn} />
            <Button value="Download Template" click={this.downloadTemplate} />
            <Button value="Upload" click={() => { this.uploadInput.click(); }} />
            <input
              type="file"
              style={{ display: 'none' }}
              ref={(e) => { this.uploadInput = e; }}
              onChange={this.uploadExcelFile}
              onClick={(e) => { e.target.value = null; }}
            />
          </div>
        </div>

        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Material Code</th>
              <th>Charged Weight</th>
              <th>Empty Bag Weight</th>
              <th>Max Tolerance</th>
              <th>Upper Tolerance</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {(toleranceData || []).map((item, index) => (
              <tr key={`tolerance_${index}`}>
                <td>{item.material_code || "-"}</td>
                <td>{item.charged_weight || "-"}</td>
                <td>{item.empty_bag_weight || "-"}</td>
                <td>{item.max_tolerance || "-"}</td>
                <td>{item.upper_tolerance || "-"}</td>
                <td>
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editToleranceMaster(item)}
                  />
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteToleranceMaster(item)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {(!toleranceData || toleranceData.length === 0) && (
          <div className="no_data_found">No Data Found</div>
        )}

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>

        {this.state.isOpen && (
          <AddToleranceMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveToleranceMasterData}
            onUpdate={this.onUpdateToleranceMasterData}
            editData={this.state.editData}
            companyId={this.props.companyId}
            branchId={this.props.branchId}
            materialOptions={this.state.materialOptions || []}
            getMaterialData={this.getMaterialData}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loader: state.loader,
  };
};

export default connect(mapStateToProps)(withRouter(ToleranceMaster));
